import { defineMessages } from 'react-intl';

export default defineMessages({
    day: {
        id: '_.date_input.day',
        defaultMessage: 'Day'
    },
    month: {
        id: '_.date_input.month',
        defaultMessage: 'Month'
    },
    year: {
        id: '_.date_input.year',
        defaultMessage: 'Year'
    }
});
